import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Automatically attach JWT token from localStorage to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    console.log('🔐 API Request Interceptor:', {
      url: config.url,
      hasToken: !!token,
      tokenLength: token?.length,
      tokenPreview: token ? `${token.substring(0, 20)}...` : 'none'
    });
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('✅ Token attached to request');
    } else {
      console.log('❌ No token found in localStorage');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// authFetch function that handles authentication and returns the response data
const authFetch = async (url, options = {}) => {
  console.log('🚀 authFetch called with URL:', url);
  try {
    const token = localStorage.getItem('jwtToken');
    console.log('🚀 authFetch token exists:', !!token);
    
    if (!token) {
      // For testing purposes, make a regular fetch request without authentication
      console.log('⚠️ No JWT token found, making unauthenticated request for testing');
      
      // Ensure URL starts with /api but doesn't duplicate it
      const apiUrl = url.startsWith('/api') ? url : `/api${url}`;
      console.log('🔍 Making request to:', apiUrl);
      
      const response = await fetch(apiUrl, {
        method: options.method || 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        body: options.body ? JSON.stringify(options.body) : undefined,
      });
      
      console.log('📊 Response status:', response.status);
      console.log('📊 Response ok:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ Response error:', errorText);
        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();
      console.log('📊 Response data:', data);
      return data;
    }

    const config = {
      url,
      method: options.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...options.headers
      },
      data: options.body, // Convert body to data for axios
    };

    // Remove body from the original options to avoid conflicts with axios data
    const { body, headers, ...restOptions } = options;
    Object.assign(config, restOptions);

    console.log('🚀 authFetch making axios request with config:', config);
    const response = await api(config);
    console.log('🚀 authFetch axios response:', response.data);
    return response.data;
  } catch (error) {
    console.error('authFetch error:', error);
    throw error;
  }
};

export default api;
export { authFetch };
